var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00994 11.2784L1.50708 16.7299C1.34641 16.8892 1.21887 17.0788 1.13184 17.2877C1.04481 17.4966 1 17.7207 1 17.947C1 18.1733 1.04481 18.3974 1.13184 18.6063C1.21887 18.8152 1.34641 19.0048 1.50708 19.1642L5.14137 22.7984C5.30073 22.9591 5.49034 23.0867 5.69924 23.1737C5.90814 23.2607 6.13221 23.3055 6.35851 23.3055C6.58482 23.3055 6.80888 23.2607 7.01779 23.1737C7.22669 23.0867 7.41629 22.9591 7.57565 22.7984L13.0271 17.2956",
    stroke: "#1974CD",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2957 13.0271L22.7471 7.57565C22.9078 7.41629 23.0353 7.22669 23.1224 7.01779C23.2094 6.80888 23.2542 6.58482 23.2542 6.35851C23.2542 6.13221 23.2094 5.90814 23.1224 5.69924C23.0353 5.49034 22.9078 5.30073 22.7471 5.14137L19.1643 1.50708C19.0049 1.34641 18.8153 1.21887 18.6064 1.13184C18.3975 1.04481 18.1734 1 17.9471 1C17.7208 1 17.4968 1.04481 17.2879 1.13184C17.079 1.21887 16.8894 1.34641 16.73 1.50708L11.2786 7.00994",
    stroke: "#1974CD",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5815 8.72412L8.72437 15.5813",
    stroke: "#1974CD",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkChain);
export default __webpack_public_path__ + "static/media/link-chain.0aec1978925ac8f134c59eb0d0318cc4.svg";
export { ForwardRef as ReactComponent };